// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"7c45f9ea","95":"126fa146","134":"6b6ae9a2","323":"e3c1bedf","444":"9edd56f2","607":"63bda135","642":"6286ef28","776":"c81fafa3","800":"6aff2e57","950":"c6355b18"}[chunkId] + ".chunk.js";
};